<template>
    <div>
        <el-tooltip class="item" effect="dark" :content="$t('pbcRsDashboardTooltip')" placement="left"
            popper-class="popper-cls">
            <span v-loading="rsDashboardLoading" element-loading-spinner="el-icon-loading"
                :class="['entry-btn', disabled ? 'entry-btn-disabled' : '']" @click="onEntryBtnClick">
                <img :src="rsdashboard_icon" alt="" class="history-icon">
            </span>
        </el-tooltip>
        <el-drawer :visible.sync="show" size="60%" custom-class="rsdashboard_class">
            <div slot="title" class="drawer-title">
                <div class="drawer-title-text">
                    {{ $t('aDashboard_title') }}
                    <GuidanceTooltip class="guidanceTooltip" :content="$t('pbc_rsdashboard_tip')" placement="right"
                        :jumpLink="$t('pbc_rsdashboard_link')"></GuidanceTooltip>
                </div>
                <div class="valueTypeSwitch">
                    <el-radio v-model="valueType" label="value">{{ $t('LIMIT_NUM') }}</el-radio>
                    <el-radio v-model="valueType" label="percent"> % </el-radio>
                    <!-- <el-button @click="onExportClick" :loading="exportLoading" class="exportBtn">{{$t('COMMON_EXPORT')}}</el-button> -->
                </div>
            </div>
            <div class="flex-column" ref="area" :key="flexColumnKey">
                <div class="level-0-container">
                    <div class="level-0-1">
                        <div>
                            <span class="level-0-1-count"> {{ data.pbcTotal }} </span>
                        </div>
                        <div class="level-0-1-title">{{ $t('pbc_items_total') }}</div>
                    </div>
                    <el-tooltip class="item" effect="dark" :content="$t('outstanding_PBC_requests_count_TIP')"
                        placement="bottom">
                        <div class="level-0 card-clickable" @click="onCardClick('02')">
                            <div>
                                <span class="level-0-count"> {{ valueType == 'value' ? data.level1[0].count :
                                    `${data.level1[0].percent} %` }} </span>
                            </div>
                            <div class="level-0-title">{{ data.level1[0].title }}</div>
                        </div>
                    </el-tooltip>
                </div>
                <el-steps direction="vertical" class="steps">
                    <!-- 第一部分,展示原始dashboard的三部分数据 -->
                    <el-step>
                        <div slot="title" class="step-title">
                            {{ $t('rsdashboard_level1') }}
                        </div>
                        <div slot="icon">
                            <img :src="level1Icon" alt="" class="level-icon">
                        </div>
                        <div :class="['level', `level-1-container`]" slot="description">
                            <el-tooltip class="item" effect="dark" v-for="(v, k) in data.level1.filter((v, k) => k > 0)"
                                :key="`level1-${k}`" :content="v.tip" placement="bottom">
                                <div :class="['card', `card-green`, 'card-clickable']"
                                    @click="onCardClick(`1${(k + 1)}`)">
                                    <div class="card-top">
                                        <div class="card-top-right">
                                            <div class="card-top-right-line1">{{ valueType == 'value' || v.hidePercent ?
                                                v.count : `${v.percent} %` }}</div>
                                            <div class="card-top-right-line2">{{ v.title }}</div>
                                        </div>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                    </el-step>
                    <!-- 第二部分,使用第一部分的后两个数据进行坠欧荡 -->
                    <el-step>
                        <div slot="title" class="step-title">
                            {{ $t('rsdashboard_level2') }}
                        </div>
                        <div slot="icon">
                            <img :src="level2Icon" alt="" class="level-icon">
                        </div>
                        <div :class="['level', `level-2-container`]" slot="description">
                            <el-tooltip class="item" effect="dark" placement="bottom" v-for="(v, k) in data.level2"
                                :key="`level2-${k}`" :disabled="v.tip == ''">
                                <div slot="content" v-html="v.tip"></div>
                                <div :class="['card', `card-green`]">
                                    <div class="card-top">
                                        <div class="card-top-left">
                                            <img :src="[smellIcon, sadIcon, sadIcon, normalIcon][k]" />
                                        </div>
                                        <div class="card-top-right">
                                            <div class="card-top-right-line1">{{ valueType == 'value' || v.hidePercent ?
                                                v.count : `${v.percent} %` }}</div>
                                            <div class="card-top-right-line2">{{ v.title }}</div>
                                        </div>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                    </el-step>

                    <!-- 第三部分 使用第二部分数据追偶荡 分维度看表格-->
                    <el-step v-show="!exportLoading">
                        <div slot="title" class="step-title">
                            {{ $t('rsdashboard_level3') }}
                        </div>
                        <div slot="icon">
                            <img :src="level3Icon" alt="" class="level-icon">
                        </div>
                        <div :class="['level', `level-3-container`]" slot="description">
                            <el-tabs v-model="activeTab" @tab-click="onTabClick">
                                <el-tab-pane :label="$t('COMMON_ENTITY')" name="entity"></el-tab-pane>
                                <el-tab-pane :label="$t('TABLE_HEADER_clientUserName')"
                                    name="cleintResponsbile"></el-tab-pane>
                                <el-tab-pane :label="$t('TABLE_HEADER_topicName')" name="account"></el-tab-pane>
                                <el-tab-pane :label="$t('TABLE_HEADER_sub_topicName')" name="subAccount"></el-tab-pane>
                            </el-tabs>
                            <el-table :data="data.level3" v-loading="dashboardTableLoading" max-height="400">
                                <el-table-column prop="target" :label="{
                                    entity: $t('COMMON_ENTITY'),
                                    cleintResponsbile: $t('TABLE_HEADER_clientUserName'),
                                    accoun: $t('TABLE_HEADER_topicName'),
                                    subAccoun: $t('TABLE_HEADER_sub_topicName')
                                }[activeTab]"></el-table-column>
                                <el-table-column :label="$t('submitted_before_deadline_pbc_request')">
                                    <template slot-scope="scope">
                                        <span> {{ valueType == 'value' ? scope.row.value21 : `${scope.row.percent21}
                                            %`}} </span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('overdued_pbc_count')">
                                    <template slot-scope="scope">
                                        <span> {{ valueType == 'value' ? scope.row.value22 : `${scope.row.percent22}
                                            %`}} </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="value23" :label="$t('overdued_on_average')"></el-table-column>
                                <el-table-column :label="$t('revision_required_count')">
                                    <template slot-scope="scope">
                                        <span> {{ valueType == 'value' ? scope.row.value24 : `${scope.row.percent24}
                                            %`}} </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-step>
                </el-steps>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import * as html2canvas from 'html2canvas'
import { exportPdf } from '@/utils/exportTable'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'

export default {
    name: 'RsDashboard',
    components: { GuidanceTooltip },
    data() {
        return {
            iconSort: ['emoji', 'normal', 'sad', 'skull'],
            colorSort: ['card-green', 'card-yellow', 'card-pink', 'card-red'],
            level1Colors: ['#ff0000', '#e58143', '#0dbc79'],
            activeTab: "entity",
            historyIcon: require(`@/assets/img/history.png`),
            level1Icon: require(`@/assets/img/icon-level-04.svg`),
            level2Icon: require(`@/assets/img/icon-level-05.svg`),
            level3Icon: require(`@/assets/img/icon-level-06.svg`),
            smellIcon: require(`@/assets/img/smell.png`),
            normalIcon: require(`@/assets/img/face-normal.png`),
            sadIcon: require(`@/assets/img/sad.png`),
            rsdashboard_icon: require(`@/assets/img/icon-historical.svg`),
            valueType: 'value',
            exportLoading: false,
            showExport: false,
            exporttable1: [],
            exporttable2: [],
            exporttable3: [],
            exporttable4: [],
            flexColumnKey: 'aaa',
            show: false
        }
    },
    props: {
        disabled: {
            type: Boolean,
            default: true
        },
        rsDashboardLoading: Boolean,
        data: {
            type: Object,
            default: () => {
                return {
                    level1: [],
                    level2: [],
                    level3: []
                }
            }
        },
        dashboardTableLoading: Boolean,
        chooseTabProp: Function,
        makeLevel3Data: Function,
        onCardClick: Function
    },
    methods: {
        hide() {
            this.show = false
        },
        // rsdashboard 导出
        async onExportClick() {
            this.exportLoading = true
            const stepHeads = document.querySelectorAll('.el-step__head')
            const stepTitle = document.querySelectorAll('.el-step__title')
            const level3 = document.querySelectorAll('.el-step__description')
            for (let i = 0; i < stepHeads.length; i++) {
                stepHeads[i].style.display = 'none'
            }
            for (let i = 0; i < stepTitle.length; i++) {
                stepTitle[i].style.display = 'none'
            }
            level3[2].style.display = 'none'


            let td = {}
            td = await this.chooseTabProp('entity')
            this.exporttable1 = this.makeLevel3Data(td.tableData)
            td = await this.chooseTabProp('cleintResponsbile')
            this.exporttable2 = this.makeLevel3Data(td.tableData)
            td = await this.chooseTabProp('account')
            this.exporttable3 = this.makeLevel3Data(td.tableData)
            td = await this.chooseTabProp('subAccount')
            this.exporttable4 = this.makeLevel3Data(td.tableData)

            const element = document.getElementsByClassName('flex-column')[0]
            const w = Math.round(document.body.clientWidth * 0.6)
            const h = element.scrollHeight
            element.style.width = `${w}px`
            element.style.height = `${h}px`

            setTimeout(() => {
                html2canvas(this.$refs.area, {
                    height: element.scrollHeight,
                    scale: 2
                }).then(res => {
                    const base64 = res.toDataURL('image/png')
                    // 表头
                    const commonColumns = [
                        this.$t('submitted_before_deadline_pbc_request'),
                        this.$t('overdued_pbc_count'),
                        this.$t('overdued_on_average'),
                        this.$t('revision_required_count')
                    ]
                    const t3h1 = [
                        this.$t('COMMON_ENTITY'),
                        ...commonColumns
                    ]
                    const t3h2 = [
                        this.$t('TABLE_HEADER_clientUserName'),
                        ...commonColumns
                    ]
                    const t3h3 = [
                        this.$t('TABLE_HEADER_topicName'),
                        ...commonColumns
                    ]
                    const t3h4 = [
                        this.$t('TABLE_HEADER_sub_topicName'),
                        ...commonColumns
                    ]
                    exportPdf({
                        level12: {
                            base64, w, h
                        },
                        level3: [
                            this.exporttable1,
                            this.exporttable2,
                            this.exporttable3,
                            this.exporttable4
                        ],
                        level3Th: [
                            t3h1,
                            t3h2,
                            t3h3,
                            t3h4
                        ],
                        valueType: this.valueType
                    }, `${this.$t('aDashboard_title')}.pdf`)

                    this.exportLoading = false
                    for (let i = 0; i < stepHeads.length; i++) {
                        stepHeads[i].style.display = 'block'
                    }
                    for (let i = 0; i < stepTitle.length; i++) {
                        stepTitle[i].style.display = 'block'
                    }
                    level3[2].style.display = 'block'
                })
                    .catch(e => {
                        console.error(e);
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => { })
            }, 2000)
        },
        onTabClick(tab) {
            this.data.level3 = []
            this.$emit('chooseTab', tab.name)
        },
        onEntryBtnClick() {
            this.$emit("getDashboardData", 'rsDashboardLoading', () => {
                this.show = true
            })
            // this.show = true
        },
        dangerLevelReverse(direction, percent) {
            let colorSort = [...this.colorSort]
            let iconSort = [...this.iconSort]
            if (direction == 2) {
                colorSort.reverse()
                iconSort.reverse()
            }

            let index;
            if (percent >= 90) {
                index = 0;
            } else if (percent < 90 && percent >= 60) {
                index = 1;
            } else if (percent < 60 && percent >= 30) {
                index = 2;
            } else {
                index = 3
            }
            return {
                colorSort: colorSort[index],
                iconSort: require(`@/assets/img/${iconSort[index]}.png`)
            }
        },
        resetTab() {
            this.activeTab = 'entity'
        }
    }
}
</script>
<style scoped>
.rsdashboard_container {
    width: 100%;
    min-height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}

.entry-btn {
    position: fixed;
    top: 440px;
    right: 0;
    width: 40px;
    height: 40px;
    display: flex;
    z-index: 10;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    text-align: center;
    background: #7213ea;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    transition: right .3s cubic-bezier(.9, 0, .3, .7);
    pointer-events: auto;
    color: #ffff;
}

.entry-btn-disabled {
    background-color: #eee;
    cursor: not-allowed;
}

.history-icon {
    position: absolute;
    width: 22px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}

.flex-column {
    display: flex;
    flex-direction: column;
    height: 60vh;
}

.drawer-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.drawer-title-text {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.drawer-title-text .guidanceTooltip {
    margin-left: 10px;
}

.valueTypeSwitch {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 30px;
}

.exportBtn {
    margin-right: 20px;
}

.steps {
    margin-left: 20px;
}

.step-title {
    color: rgb(68, 68, 144);
}

.level-icon {
    width: 20px;
    height: 20px;
}

.level {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.level-0-container {
    display: flex;
    flex-direction: row;
}

.level-0-1 {
    width: 208px;
    height: 94px;
    border-radius: 10px;
    background-color: #0d386d;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 0 20px 80px;
    color: white;
}

.level-0-1-title {
    color: white;
    font-size: 16px;
    font-weight: 500;
}

.level-0-1-count {
    color: white;
    font-size: 32px;
}

.level-0-1-title,
.level-0-1-count {
    margin-left: 20px;
}

.level-0 {
    width: 208px;
    height: 94px;
    border-radius: 10px;
    background-color: #fef0f0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 0 20px 20px;
}

.level-0-title {
    color: #da4949;
    font-size: 16px;
    font-weight: 500;
}

.level-0-count {
    color: #f56c6c;
    font-size: 32px;
}

.level-0-percent {
    font-size: 14px;
    margin-left: 10px;
    color: #f56c6c;
}

.level-0-title,
.level-0-count {
    margin-left: 20px;
}

.level1-row {
    width: 100%;
    height: 30px;
    background-color: #efeff5;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 20px;
    overflow: hidden;
}

.level1-row-item {
    height: 100%;
    overflow: hidden;
}

.level1-tip-1 {
    display: flex;
    flex-direction: row;
    font-size: 1.2em;
}

.level1-tip-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.level1-tip-21,
.level1-tip-22 {
    display: flex;
    flex-direction: row;
}

.level1-tip-22 {
    justify-content: flex-end;
}

.level-2 {
    margin-top: 60px;
}

.level-1-container,
.level-2-container {
    margin-left: 20px;
}

.level-1-container {
    height: 150px;
    display: flex;
}

.card {
    width: 208.5px;
    height: 114px;
    display: flex;
    flex-direction: column;
    margin: 20px 10px;
    color: white;
    /* padding: 10px 20px; */
    border-radius: 10px;
    position: relative;
    overflow: hidden;
}

.card-clickable {
    cursor: pointer;
}

.card-process {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10;
}

.card-green {
    background-color: #409eff;
}

.card-yellow {
    background-color: rgb(230, 162, 60);
}

.card-pink {
    background-color: rgb(245, 108, 108);
}

.card-red {
    background-color: rgb(255, 0, 0);
}

.card-green-process {
    background-color: rgb(132, 202, 96);
}

.card-yellow-process {
    background-color: rgb(226, 180, 110);
}

.card-pink-process {
    background-color: rgb(240, 151, 151);
}

.card-red-process {
    background-color: rgb(228, 89, 89);
}

.card-top {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    z-index: 11;
    height: 100%;
}

.card-top-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.card-top-left img {
    width: 50px;
    height: 50px;
}

.card-top-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    margin-right: 20px;
    height: 100%;
}

.card-top-right-line1 {
    font-size: 32px;
}

.card-top-right-line2 {
    font-size: 16px;
    margin-top: 5px;
    width: 100px;
}

.card-bottom-process {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    z-index: 11;
}

.level-3-container {
    display: flex;
    flex-direction: column;
}

#rsDashboardCapture {
    width: 1200px;
    min-height: 1000px;
    background-color: white;
}

::v-deep .el-step__icon.is-text {
    border: none;
}

::v-deep .el-step__line {
    background-color: rgb(64, 158, 255) !important;
}

::v-deep .el-step__icon i {
    color: rgb(64, 158, 255);
}

::v-deep .el-table {
    overflow: visible;
}
</style>